/*
 * Custom Product Options
 * Handles atomic add-to-cart with fee products and cart sync for personalization fields.
 */
(function($) {
  'use strict';

  var CustomOptions = {
    init: function() {

      this.bindAddToCart();
      this.bindFormSubmit();
      this.bindCartSync();

    },

    // -------------------------------------------------------------------
    // Add-to-cart interception (AJAX mode)
    // -------------------------------------------------------------------
    bindAddToCart: function() {
      var self = this;

      // Use capture phase so this fires BEFORE the jQuery delegated handler
      // in app.js.liquid (line 684). For addon products we preventDefault +
      // stopImmediatePropagation so the default handler never fires.
      // For non-addon or non-custom products, we let the event through.

      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.ajax-submit');
        if (!btn) return;


        var $btn = $(btn);
        var $form = $btn.closest('form');
        var $optionsContainer = $form.find('[data-custom-options]');

        // No custom options — let default handler run
        if ($optionsContainer.length === 0) {

          return;
        }

        var isAddon = $optionsContainer.data('custom-addon') === true ||
                      $optionsContainer.data('custom-addon') === 'true';


        // Validate required fields
        if (!self.validateFields($form)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }

        // If not an addon, let default handler run — properties are in the form inputs
        if (!isAddon) {

          return;
        }

        // Addon product — stop default handler, do atomic add
        e.preventDefault();
        e.stopImmediatePropagation();

        var items = self.buildItemsArray($form, $optionsContainer);

        if (items.length === 0) return;

        self.submitAtomicAdd(items, $form, $btn);
      }, true); // useCapture = true — runs before jQuery delegation
    },

    // -------------------------------------------------------------------
    // Form submit interception (non-AJAX modes: reload_page, redirect_checkout)
    // -------------------------------------------------------------------
    bindFormSubmit: function() {
      var self = this;

      document.addEventListener('submit', function(e) {
        var form = e.target;
        if (!form || !form.querySelector) return;
        // Match product forms — they live inside [data-product-form] or post to /cart/add
        var isProductForm = form.closest('[data-product-form]') ||
                            (form.action && form.action.indexOf('/cart/add') !== -1);
        if (!isProductForm) return;

        var $form = $(form);
        var $optionsContainer = $form.find('[data-custom-options]');
        if ($optionsContainer.length === 0) return;

        var isAddon = $optionsContainer.data('custom-addon') === true ||
                      $optionsContainer.data('custom-addon') === 'true';

        if (!self.validateFields($form)) {
          e.preventDefault();
          return;
        }

        if (!isAddon) return;

        // Intercept: add atomically via AJAX, then redirect
        e.preventDefault();

        var items = self.buildItemsArray($form, $optionsContainer);
        var returnTo = $form.find('[name="return_to"]').val();

        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          contentType: 'application/json',
          data: JSON.stringify({ items: items }),
          success: function() {
            window.location.href = returnTo || '/cart';
          },
          error: function(xhr) {
            var response;
            try { response = JSON.parse(xhr.responseText); } catch(err) { response = { description: 'Unable to add item to cart' }; }
            $('.warning').remove();
            $form.after($('<p class="warning animated bounceIn"></p>').text(response.description));
          }
        });
      }, true);
    },

    // -------------------------------------------------------------------
    // Validation
    // -------------------------------------------------------------------
    validateFields: function($form) {
      var valid = true;

      $form.find('[data-custom-options] input[required]').each(function() {
        var $input = $(this);
        $input.removeClass('custom-options__error');
        $input.siblings('.custom-options__error-message').remove();

        if ($.trim($input.val()) === '') {
          valid = false;
          $input.addClass('custom-options__error');
          $input.after('<p class="custom-options__error-message">This field is required</p>');
        }
      });

      return valid;
    },

    // -------------------------------------------------------------------
    // Build items array for atomic /cart/add.js POST
    // -------------------------------------------------------------------
    buildItemsArray: function($form, $optionsContainer) {
      var items = [];

      // 1. Build the main product item from the form
      var variantId = $form.find('[name="id"]').val();
      var quantity = parseInt($form.find('[name="quantity"]').val()) || 1;

      var properties = {};
      $optionsContainer.find('input[data-custom-field]').each(function() {
        var val = $.trim($(this).val());
        if (val !== '') {
          properties[$(this).attr('name').replace('properties[', '').replace(']', '')] = val;
        }
      });

      // Generate a unique ID to link fee items to this product
      var linkId = variantId + '-' + Date.now();
      properties['_customization_link'] = linkId;

      items.push({
        id: parseInt(variantId),
        quantity: quantity,
        properties: properties
      });

      // 2. Add fee products based on which fields are filled
      var lastNameVal = $.trim($optionsContainer.find('[data-custom-field="last-name"]').val());
      var numberVal = $.trim($optionsContainer.find('[data-custom-field="number"]').val());
      var initialsOrNumberVal = $.trim($optionsContainer.find('[data-custom-field="initials-or-number"]').val());

      var lastnameVariantId = $optionsContainer.data('lastname-fee-variant-id');
      var numberVariantId = $optionsContainer.data('number-fee-variant-id');

      if (lastNameVal !== '' && lastnameVariantId) {
        items.push({
          id: parseInt(lastnameVariantId),
          quantity: quantity,
          properties: { '_customization_link': linkId }
        });
      }

      if ((numberVal !== '' || initialsOrNumberVal !== '') && numberVariantId) {
        items.push({
          id: parseInt(numberVariantId),
          quantity: quantity,
          properties: { '_customization_link': linkId }
        });
      }

      return items;
    },

    // -------------------------------------------------------------------
    // Atomic add-to-cart POST (mirrors app.js.liquid success/error UX)
    // -------------------------------------------------------------------
    submitAtomicAdd: function(items, $form, $btn) {
      var $addToCartBtn = $form.find('.add_to_cart');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        contentType: 'application/json',
        data: JSON.stringify({ items: items }),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success: function() {
          // Mirror the success behavior from app.js.liquid
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          window.setTimeout(function() {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          // Refresh the cart display
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success: function(cart) {
              setTimeout(function() {
                if (typeof window.refreshCart === 'function') {
                  window.refreshCart(cart);
                }
                // Activate cart container (same logic as app.js.liquid)
                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                  $('.rightlogin .cart-container').addClass('active_link');
                  $('.mobnavright .cart-container').addClass('active_link');
                }
              }, 500);
            }
          });
        },
        error: function(xhr) {

          var response;
          try {
            response = JSON.parse(xhr.responseText);
          } catch(e) {
            response = { description: 'Unable to add item to cart' };
          }
          $('.warning').remove();
          $form.after($('<p class="warning animated bounceIn"></p>').text(response.description));
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span')
            .text(window.PXUTheme.translation.add_to_cart)
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    },

    // -------------------------------------------------------------------
    // Cart sync — remove/re-quantity fee items when parent changes
    // -------------------------------------------------------------------
    bindCartSync: function() {
      var self = this;

      // Listen for cart item removal via the mini-cart and cart page
      $(document).on('click', '.js-cart-remove-btn, .cart__remove-btn', function() {
        // After a short delay (let the default removal complete), sync fees
        setTimeout(function() {
          self.syncCartFees();
        }, 1000);
      });

      // Listen for quantity changes on the cart page
      $(document).on('change', '[data-cart-form="cart-template"] input[name^="updates"]', function() {
        setTimeout(function() {
          self.syncCartFees();
        }, 1000);
      });
    },

    syncCartFees: function() {
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false,
        success: function(cart) {
          var items = cart.items;
          var updates = {};
          var needsUpdate = false;

          // Build a map of link IDs to their parent quantities
          var linkMap = {};
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.properties && item.properties['_customization_link']) {
              var linkId = item.properties['_customization_link'];
              // Parent items have more than just _customization_link in their properties
              var propCount = Object.keys(item.properties).length;
              if (propCount > 1) {
                linkMap[linkId] = { quantity: item.quantity, line: i + 1 };
              }
            }
          }

          // Check fee items and sync quantities or mark for removal
          for (var j = 0; j < items.length; j++) {
            var feeItem = items[j];
            if (feeItem.properties && feeItem.properties['_customization_link']) {
              var feeLinkId = feeItem.properties['_customization_link'];
              var feePropCount = Object.keys(feeItem.properties).length;

              // Fee items only have _customization_link (propCount === 1)
              if (feePropCount === 1) {
                var parent = linkMap[feeLinkId];
                if (!parent) {
                  // Parent was removed — remove fee
                  updates[j + 1] = 0;
                  needsUpdate = true;
                } else if (parent.quantity !== feeItem.quantity) {
                  // Parent quantity changed — sync fee quantity
                  updates[j + 1] = parent.quantity;
                  needsUpdate = true;
                }
              }
            }
          }

          if (needsUpdate) {
            // Process updates sequentially via /cart/change.js to avoid race conditions
            var lineUpdates = [];
            for (var k = 0; k < items.length; k++) {
              var lineNum = k + 1;
              if (updates.hasOwnProperty(lineNum)) {
                lineUpdates.push({ line: lineNum, quantity: updates[lineNum] });
              }
            }

            // Sort descending so removals (quantity 0) don't shift line indices
            lineUpdates.sort(function(a, b) { return b.line - a.line; });

            var processUpdate = function(index) {
              if (index >= lineUpdates.length) {
                // All updates done, refresh cart
                $.ajax({
                  url: '/cart.js',
                  dataType: 'json',
                  cache: false,
                  success: function(finalCart) {
                    if (typeof window.refreshCart === 'function') {
                      window.refreshCart(finalCart);
                    } else if ($('body').hasClass('cart')) {
                      location.reload();
                    }
                  }
                });
                return;
              }

              $.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: {
                  line: lineUpdates[index].line,
                  quantity: lineUpdates[index].quantity
                },
                success: function() {
                  processUpdate(index + 1);
                }
              });
            };

            processUpdate(0);
          }
        }
      });
    }
  };

  // Initialize when DOM is ready
  $(function() {
    CustomOptions.init();
  });

})(jQuery);
